import { render, staticRenderFns } from "./ContainerFlat.vue?vue&type=template&id=06ba488b&scoped=true&"
import script from "./ContainerFlat.vue?vue&type=script&lang=js&"
export * from "./ContainerFlat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba488b",
  null
  
)

export default component.exports